'use-client';
import { GoogleCalendarIcon, BackArrow } from '@mybridge/icons';
import {
  Flex,
  Heading,
  useDisclosure,
  Spinner,
  Box,
  HStack,
} from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';
import { Input } from '@mybridge/ui/input';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Text } from '@mybridge/ui/text';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getGoogleIntegrationUrl,
  getOutlookIntegrationUrl,
  getGoogleIntegrationCallback,
  getZoomIntegrationCallback,
  getMsTeamsIntegrationCallback,
  getWebexIntegrationCallback,
  getGotoIntegrationCallback,
} from 'packages/mybridgev4/store/slices/settingsSlice.js';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCalendarIntegrationURL,
  getIntegrationURL,
} from 'v4/lib/api/google-integration';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { useRouter } from 'next/router';
import { useToast } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
import Calendar from './calendar/Calendar';
import VideoConfrencing from './video-conferenc/VideoConfrencing';
import { getWebexMeetIntegrationUrl } from 'v4/lib/api/zoom-integration';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
export default function Integration({ setSelectedComponent, selectedSubItem }) {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const router = useRouter();
  const toast = useToast();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const [modalOpen, setModalOpen] = useState(false);
  const [heading, setHeading] = useState(null);
  const [googleLinked, setGoogleLinked] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  const getUserSlug = () => {
    return userProfileInfo?.slug || userProfileInfo?.username || null;
  };

  const trackIntegration = () => {
    const userSlug = getUserSlug();
    if (!userSlug) return;

    trackEvent(ANALYTICS_EVENTS.Integrations, userSlug, {
      device_type: isMobile ? 'mobile' : 'desktop',
      timestamp: new Date().toISOString()
    });
  };

  useEffect(()=>{
    trackIntegration();
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.addEventListener(
      'message',
      (event) => {
        if (event.data?.msg == 'showIntegrationModal') {
          setModalOpen(true);
        }
      },
      []
    );
  });

  const { googleIntLink } = useQuery(
    ['getCalIntLink'],
    getCalendarIntegrationURL,
    {
      refetchOnWindowFocus: false,
      onError(err) {
        console.log(err);
      },
      onSuccess(data) {
        if (data.error === 'already_integrated') {
          setGoogleLinked(true);
        }
      },
    }
  );
  const { mutate, isLoading, error } = useMutation(getCalendarIntegrationURL, {
    onSuccess: (data) => {

      setHeading('google');
      if (data?.error) {
        alert(data.error);
      } else {
        const { url = null } = data;
        // const url =
        //   'https://accounts.google.com/o/oauth2/v2/auth?client_id=350980133077-q3kqbcvc6umqeb09lqv9jg2b9vod68f5.apps.googleusercontent.com&redirect_uri=http%3A%2F%2Flocalhost:4200%2Fsettings%2Fintegration&response_type=code&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar&access_type=offline&state=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzA2Nzc2NDEwLCJpYXQiOjE3MDY2OTAwMTAsImp0aSI6IjA1NmMwMzMxZWRiNTQxZTVhYWQ0YzY4NDQ2YTU2Mzc5IiwidXNlcl9pZCI6NzcwfQ.A5L1TVdWzPCPH2nayq6L-B4jowmHccXFZ2tWQwxNzlE&include_granted_scopes=true';
        // console.log(url);
        if (url) {
          // window.open(url, 'mywin', 'width=500,height=500');
          router.push(url);
        }
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });
  //   const navigate = useNavigate();
  const integrateCalender = (platform) => {
    switch (platform) {
      case 'google':
        dispatch(getGoogleIntegrationUrl())
          .then((res) => {
            window.open(res.payload.url, '_blank', 'width=500,height=500');
            // navigate(googleIntegrationUrl);
          })
          .catch((err) => console.log('Integrating google failed', err));
        break;
      case 'outlook':
        dispatch(getOutlookIntegrationUrl())
          .then((res) => {
            window.open(res.payload.url, '_blank', 'width=500,height=500');
            // navigate(outlookIntegrationUrl);
          })
          .catch((err) => console.log('Integrating google failed', err));
        break;
      default:
        break;
    }
  };

  const { mutate: contactMutate, loading } = useMutation(getIntegrationURL, {
    onSuccess: (data) => {
      const { url = null } = data?.data;
      // const url = 'https://accounts.google.com/o/oauth2/v2/auth?client_id=350980133077-q3kqbcvc6umqeb09lqv9jg2b9vod68f5.apps.googleusercontent.com&redirect_uri=http%3A%2F%2Flocalhost:4200%2Fsettings%2Fintegration&response_type=code&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcontacts.readonly&access_type=offline&state=public__770&include_granted_scopes=true';
      // setHeading('contacts');
      if (url) {
        window.open(url, 'mywin', 'width=500,height=500');
        // window.open(url);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleClick = (e) => {
    contactMutate();
  };

  // useEffect(() => {
  //   if (router?.query?.code) {
  //     const payload = {
  //       state: router?.query?.state,
  //       scope: router?.query?.scope,
  //       code: router?.query?.code,
  //       prompt: router?.query?.prompt,
  //       authuser: router?.query?.authuser,
  //       hd: router?.query?.hd,
  //     };
  //     dispatch(getGoogleIntegrationCallback(payload)).then((res) => {
  //       if (res?.payload?.status_code === 200) {
  //         toast({
  //           title: 'Success',
  //           description: res?.payload?.data,
  //           status: 'success',
  //           duration: 9000,
  //           isClosable: true,
  //         });
  //          router?.push('/settings/integration/conferencing')
  //       } else {
  //         toast({
  //           title: 'Error',
  //           description: 'Something went wrong!',
  //           status: 'error',
  //           duration: 9000,
  //           isClosable: true,
  //         });
  //         router.push('/settings/integration?status=failed');
  //       }
  //     });
  //   }
  // }, [router]);



  useEffect(() => {
    const isClient = typeof window !== 'undefined';
    const { query } = router;
  
    const createPayload = () => ({
      state: query?.state,
      scope: query?.scope,
      code: query?.code,
      prompt: query?.prompt,
      authuser: query?.authuser,
      hd: query?.hd,
    });
  
    const handleIntegrationCallback = (callback, successMessage, errorMessage) => {
      const payload = createPayload();
      dispatch(callback(payload))
        .then((res) => {
          if (res?.payload?.error && errorMessage) {
            toast({
              // title: 'Error',
              description:
                res?.payload?.detail || errorMessage,
              status: 'error',
              duration: 10000,
              isClosable: true,
              position: 'top',
            });
          } else {
            toast({
              title: res?.payload?.message || "Integration successful",
              description: res?.payload?.data || successMessage,
              status: 'success',
              duration: 9000,
              isClosable: true,
              position: 'top',
            });
          }
          // Check if redirectToScheduleMeet is set in localStorage
          if (typeof window !== 'undefined' && localStorage.getItem('redirectToScheduleMeet') === 'true') {
            // localStorage.removeItem('redirectToScheduleMeet');
            router?.push('/profile/calendar/schedule');
          } else if (typeof window !== 'undefined' && localStorage.getItem('redirectToCreateAppointment') === 'true') {
            router?.push('/profile/calendar/appointments');
          } else if (typeof window !== 'undefined' && localStorage.getItem('redirectToScheduleEvent') === 'true') {
            // Get the stored path and redirect back to the event form
            const eventPath = localStorage.getItem('redirectToScheduleEventPath') || '/myevents/create';
            localStorage.removeItem('redirectToScheduleEvent');
            localStorage.removeItem('redirectToScheduleEventPath');
            // Note: redirectToScheduleEventType will be cleaned up by choose-event.js if path is choose-event
            // For other paths, we clean it up here
            if (!eventPath.includes('choose-event')) {
              localStorage.removeItem('redirectToScheduleEventType');
            }
            router?.push(eventPath);
          // } else {
          //   router?.push('/settings/integration/');
          // }
          } else if (typeof window !== 'undefined' && localStorage.getItem('redirectToCalendar') === 'true') {
            localStorage.removeItem('redirectToCalendar');
            router?.push('/profile/calendar');
          } else {
            router?.push('/settings/integration/');
          }
          // router?.push('/settings/integration/conferencing');

        })
        .catch((err) => {
          console.error('Integration error:', err);
        });
    };
  
    if (isClient && query?.code) {
      if (
        query?.scope &&
        !['zoom', 'teams', 'webex', 'gotomymeeting']?.some(slug => query?.slug?.includes(slug))
      ) {
        handleIntegrationCallback(
          getGoogleIntegrationCallback,
          t('otherModules.googleIntegrationSuccess') || 'Google integration successful'
        );
      } else if (query?.slug?.includes('teams')) {
        handleIntegrationCallback(
          getMsTeamsIntegrationCallback,
          t('otherModules.teamsIntegrationSuccess') || 'Teams integration successful',
          t('otherModules.teamsPersonalAccountError') || 'Microsoft does not support online meetings for personal accounts. To use this integration, please create a Microsoft Teams account or an Office 365 Education account.'
        );
      } else if (!query?.scope && query?.slug?.includes('zoom')) {
        handleIntegrationCallback(
          getZoomIntegrationCallback,
          t('otherModules.zoomIntegrationSuccess') || 'Zoom integration successful'
        );
      } else if (!query?.scope && query?.slug?.includes('webex')) {
        handleIntegrationCallback(
          getWebexIntegrationCallback,
          t('otherModules.webexIntegrationSuccess') || 'Webex integration successful'
        );
      } else if (!query?.scope && query?.slug?.includes('gotomymeeting')) {
        handleIntegrationCallback(
          getGotoIntegrationCallback,
          t('otherModules.gotoIntegrationSuccess') || 'GoTo Meeting integration successful'
        );
      }
    }
  }, [router]);
  



  return (
    <AuthenticatedProviders>
      {selectedSubItem === 'calendar-sync' && <Calendar setSelectedComponent={setSelectedComponent} />}
      {selectedSubItem === 'video-conferencing' && <VideoConfrencing setSelectedComponent={setSelectedComponent}/>}
    </AuthenticatedProviders>
  );
}
